
export const AuthEventType = Object.freeze({
  BEFORE_SIGN_IN: 'BEFORE_SIGN_IN',
  AFTER_SIGN_IN: 'AFTER_SIGN_IN',
  AFTER_SIGN_OUT: 'AFTER_SIGN_OUT',
  SIGN_IN_ERROR: 'SIGN_IN_ERROR',
  START_PROCESSING: 'START_PROCESSING',
  END_PROCESSING: 'END_PROCESSING'
})

export class AuthEventCore {
  constructor(authEventBus) {
    this.authEventBus = authEventBus
  }

  onBeforeSignIn(eventHandler) {
    this.authEventBus.$on(AuthEventType.BEFORE_SIGN_IN, eventHandler)
  }
  onAfterSignIn(eventHandler) {
    this.authEventBus.$on(AuthEventType.AFTER_SIGN_IN, eventHandler)
  }
  onSignOut(eventHandler) {
    this.authEventBus.$on(AuthEventType.AFTER_SIGN_OUT, eventHandler)
  }
  onSignInError(eventHandler) {
    this.authEventBus.$on(AuthEventType.SIGN_IN_ERROR, eventHandler)
  }
  onStartProcessing(eventHandler) {
    this.authEventBus.$on(AuthEventType.START_PROCESSING, eventHandler)
  }
  onEndProcessing(eventHandler) {
    this.authEventBus.$on(AuthEventType.END_PROCESSING, eventHandler)
  }  
 
}


export class AuthEventBusEmiter {
  constructor(authEventBus) {
    this.authEventBus = authEventBus
  }
  callBeforeSignIn() {
    this.authEventBus.$emit(AuthEventType.BEFORE_SIGN_IN)
  }
  async callAfterSignIn(vue) {
    this.authEventBus.$emit(AuthEventType.AFTER_SIGN_IN)
    if (vue.prototype.$eventHandlerApi && vue.prototype.$eventHandlerApi.callAfterSignInEventHandler) {
      vue.prototype.$eventHandlerApi.callAfterSignInEventHandler()
    }
    if (vue.$routerCore.doAfterSignInAction) {
      await vue.$routerCore.doAfterSignInAction(true)
    }
  }
  callSignOut() {
    this.authEventBus.$emit(AuthEventType.AFTER_SIGN_OUT)
  }
  callSignInError(errorObject) {
    this.authEventBus.$emit(AuthEventType.SIGN_IN_ERROR, errorObject)
  }
  callStartProcessing(id) {
    this.authEventBus.$emit(AuthEventType.START_PROCESSING, id)
  }
  callEndProcessing(id) {
    this.authEventBus.$emit(AuthEventType.END_PROCESSING, id)
  }
  
}